import longpress from './module/longpress';

const directives = {
    longpress
};

export default directives;



// WEBPACK FOOTER //
// ./src/directive/directives.js